import { Directive, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[ngInit]'
})
export class InitDirective implements OnInit {
  @Output() ngInit: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();

  constructor(private element: ElementRef) {}

  ngOnInit(): void {
      this.ngInit.emit(this.element);
  }
}